<mat-card class="visa-eligibility-card">
  <h1 class="visa-product-hp__title mat-display-1">
    {{ (customVariables$ | async).product_name }}
  </h1>
  <div class="visa-product-hp__body mat-subheading-2">
    {{ (customVariables$ | async)?.visa_lac_registration }}
  </div>
  <div [formGroup]="eligibilityForm" *ngIf="(siteSettings$ | async)?.switches.self_registration">
    <input
      autocomplete="off"
      class="visa-product-hp__card-number"
      [placeholder]="'ProductHomePageVisa:CardNumber' | translate"
      formControlName="cardNumber"
      aria-describedby="invalid-error"
    />
    <div ngxErrors="cardNumber">
      <span
        class="visa-product-hp__invalid-card mat-caption"
        ngxError="invalidCardNumber"
        when="touched"
        role="alert"
        [translate]="'ProductHomePageVisa:InvalidCardNumber'"
        id="invalid-error"
      >
        Invalid card number
      </span>
    </div>
    <re-captcha
      *ngIf="captchaLanguage && enableRecaptcha"
      site_key="6LeS4KsUAAAAAH5apd5lwvbc8WLWNgi16d2CprVP"
      language="{{ captchaLanguage }}"
      [tabindex]="-1"
      size="invisible"
      [global]="true"
      (captchaResponse)="getCaptchaToken($event)"
    >
    </re-captcha>
  </div>
  <button
    aria-label="Check eligibility and register"
    mat-raised-button
    class="visa-product-hp__eligibility-button"
    color="accent"
    (click)="enableRecaptcha ? checkEligibility() : getCaptchaToken('')"
    [disabled]="eligibilityForm.invalid"
    *ngIf="(siteSettings$ | async)?.switches.self_registration"
  >
    {{ 'ProductHomePageVisa:CheckEligibilityButton' | translate }}
  </button>
  <p class="visa-product-hp__caption mat-body mt-3">
    <span [translate]="'ProductHomePageVisa:RegistrationCaption'">To contact your Lifestyle Manager directly call</span>
    &nbsp;
    <a [href]="'tel: ' + (phoneNumber$ | async)"> {{ phoneNumber$ | async }}</a>
  </p>
</mat-card>
